import React, { useState } from "react";
import Header from "../components/Header3";
import Footer from "../Screen/Footer";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { Row, Col } from "react-bootstrap";
import Blog1 from "../Images/Blog1.jpg";
import Blog2 from "../Images/blog2.jpg";
import Blog3 from "../Images/blog3.jpg";
import Blog4 from "../Images/blog4.jpg";
import Blog6 from "../Images/Blog6.jpg";
import Blog5 from "../Images/blog5.jpg";
import Blog7 from "../Images/blog7.jpg";
import Blog8 from "../Images/blog8.jpg";
import Blog11 from "../Images/Blog11.jpg";
import Blog12 from "../Images/Blog12.jpg";
import Blog13 from "../Images/Blog13.jpg";
import Blog14 from "../Images/Blog14.jpg";
import Blog15 from "../Images/Blog15.jpg";
import Blog9 from "../Images/Blog9.png";
import Blog10 from "../Images/Blog10.png";
import Blog18 from "../Images/Blog18.jpg";
import Blog17 from "../Images/Blog17.jpg";
import Blog16 from "../Images/Blog16.jpg";
import Blog19 from "../Images/Blog19.jpg";
import Blog20 from "../Images/Blog20.jpg";
import Blog21 from "../Images/Blog21.jpg";
import Blog22 from "../Images/Blog22.jpg";
import Blog23 from "../Images/Blog23.jpg";
import Blog24 from "../Images/Blog24.jpg";
import Blog25 from "../Images/Blog25.jpg";
import Blog26 from "../Images/Blog26.jpg";
import Blog27 from "../Images/Blog27.jpg";
import Blog28 from "../Images/Blog28.jpg";
import BlogUAE1 from "../Images/BlogUAE1.jpg";
import BlogUAE2 from "../Images/BlogUAE2.jpg";
import BlogUAE3 from "../Images/BlogUAE3.jpg";
import BlogUAE4 from "../Images/BlogUAE4.jpg";
import BlogUAE5 from "../Images/BlogUAE5.jpg";
import BlogUAE6 from "../Images/BlogUAE6.jpg";
import "../Screen/blogs.css";

// const allBlogs = [
//   {
//     id: 1,
//     category: "realEstate",
//     title:
//       "From Clicks to Visits: Lean Strategies to Convert Real Estate Leads into Property Viewings",
//     date: "25 November 2024",
//     desc: "Struggling to turn real estate leads into property viewings? Discover lean strategies to optimize your lead conversion process and drive more visits to your properties.",
//     img: Blog2,
//     link: "blogs/real-estate/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings",
//   },
//   {
//     id: 2,
//     category: "realEstate",
//     title: "7 Game-Changing Tips to Attract High-Quality Leads",
//     date: "25 November 2024",
//     desc: "Meta Ads is a great platform for generating high-quality leads. In this blog, we'll explore seven tips to help you attract top-notch leads using Meta Ads. You'll also learn why focusing on lead quality.",
//     img: Blog4,
//     link: "blogs/real-estate/7-game-changing-tips-to-attract-high-quality-leads-with-meta-ads",
//   },
//   {
//     id: 3,
//     category: "realEstate",
//     title:
//       "11 Proven Ways to Attract High-Quality Leads Using Google Ads (2024)",
//     date: "25 November 2024",
//     desc: "Google Ads is the best way to attract High-converting leads that drive business growth. To ensure your ads reach potential customers, it's crucial to use targeted strategies.",
//     img: Blog3,
//     link: "blogs/real-estate/11-proven-ways-to-attract-high-quality-leads-using-google-ads-2024",
//   },
//   {
//     id: 4,
//     category: "ecommerce",
//     title:
//       "How to Generate Leads on a Zero Marketing Budget: B2C and B2B Strategies",
//     date: "25 November 2024",
//     desc: "Generating leads is important for any business. There are effective ways to attract potential customers and clients without spending money. In this guide, we'll look at lead generation",
//     img: Blog5,
//     link: "blogs/e-commerce/how-to-generate-leads-on-a-zero-marketing-budget-b2c-and-b2b-strategies",
//   },
//   {
//     id: 5,
//     category: "ecommerce",
//     title:
//       "10 Lean Strategies to Supercharge Your E-commerce ROAS: A Blaccdot Guide",
//     date: "25 November 2024",
//     desc: "Discover 10 powerful lean strategies to improve your e-commerce ROAS with expert insights from Blaccdot.",
//     img: Blog1,
//     link: "blogs/e-commerce/10-lean-strategies-to-boost-e-commerce-roas",
//   },
//   {
//     id: 6,
//     category: "health",
//     title: "8 Proven Ways to Get More Leads for Your Dental Clinic",
//     date: "23 September 2025",
//     desc: "Strategies to boost patient acquisition for your dental clinic.Explore both organic and paid lead generation methods to attract, engage, and convert prospective patients.",
//     img: Blog6,
//     link: "blogs/health/8-proven-ways-to-get-more-leads-for-your-dental-clinic",
//   },
//   {
//     id: 7,
//     category: "realEstate",
//     title:
//       "Google Ads vs Meta Ads: Which is Better for Real Estate Lead Generation in India 2025",
//     date: "23 September 2025",
//     desc: "Explore Google Ads vs Meta Ads for real estate lead generation in India. Discover which platform suits your business goals, and learn best practices for maximizing your advertising efforts in 2025.",
//     img: Blog7,
//     link: "blogs/real-estate/google-ads-vs-meta-ads-which-is-better-for-real-estate-lead-generation-in-india-2025",
//   },
//   {
//     id: 8,
//     category: "realEstate",
//     title:
//       "7 Proven Ways to Generate Real Estate Leads with Google Ads | Blaccdot",
//     date: "23 September 2025",
//     desc: "The proven strategies to generate high-quality real estate leads using Google Ads. Optimize your campaigns with effective keyword targeting, compelling ad copy, and efficient lead management with Blaccdot.",
//     img: Blog8,
//     link: "blogs/real-estate/7-proven-ways-to-generate-real-estate-leads-with-google-ads-blaccdot",
//   },
//   {
//     id: 9,
//     category: "realEstate",
//     title:
//       "Biggest Real Estate Lead Generation Challenges in India and Solutions",
//     date: "23 September 2025",
//     desc: "Struggling with real estate leads? Discover the 8 biggest real estate lead generation challenges in India—from unqualified leads to high competition—and learn actionable solutions for real estate business success",
//     img: Blog9,
//     link: "blogs/real-estate/biggest-real-estate-lead-generation-challenges-in-india-and-solutions",
//   },
//   {
//     id: 10,
//     category: "realEstate",
//     title:
//       "How to Create a Winning Real Estate Leads Funnel in India for Higher Sales",
//     date: "23 September 2025",
//     desc: "Learn the 7 steps to build a high-converting real estate leads funnel in India. Master capturing, nurturing, and converting leads with targeted ads, buyer personas, and powerful retargeting strategies.",
//     img: Blog10,
//     link: "blogs/real-estate/how-to-create-a-winning-real-estate-leads-funnel-in-india-for-higher-sales",
//   },
//   {
//     id: 11,
//     category: "realEstate",
//     title: "Proven Follow-Up Strategies for Real Estate Success in Chennai",
//     date: "29 October 2025",
//     desc: " Learn how to follow up smartly with real estate leads in Chennai. Turn enquiries into site visits with proven follow-up techniques.",
//     img: Blog11,
//     link: "blogs/real-estate/real-estate-follow-up-strategies-chennai",
//   },
//   {
//     id: 12,
//     category: "realEstate",
//     title:
//       "The Perfect Lead Follow-Up Timeline: When and How to Reach Out for Maximum Real Estate Conversions",
//     date: "29 October 2025",
//     desc: " Learn the ideal real estate follow-up schedule for Chennai property leads. Convert more buyers with our proven day-by-day timeline.",
//     img: Blog12,
//     link: "blogs/real-estate/real-estate-lead-follow-up-timeline-chennai",
//   },
//   {
//     id: 13,
//     category: "realEstate",
//     title:
//       "From Inquiry to Site Visit: How to Nurture Low-Intent Real Estate Leads in Chennai",
//     date: "29 October 2025",
//     desc: " Learn how to turn Low-Intent real estate leads into site visits with smart nurturing strategies designed for Chennai’s property market.",
//     img: Blog13,
//     link: "blogs/real-estate/nurture-real-estate-leads-chennai",
//   },
//   {
//     id: 14,
//     category: "realEstate",
//     title:
//       " The 7-Day Follow-Up Blueprint: Turn More Property Leads into Buyers Without Being Pushy",
//     date: "30 October 2025",
//     desc: " Follow this 7-day real estate follow-up blueprint to convert more Chennai property leads into site visits — without sounding pushy.",
//     img: Blog14,
//     link: "blogs/real-estate/7-day-follow-up-plan-chennai-real-estate",
//   },
//   {
//     id: 15,
//     category: "realEstate",
//     title:
//       "How to Build Trust with Real Estate Leads: The Long-Term Conversion Secret for Chennai Property Sellers",
//     date: "30 October 2025",
//     desc: " Learn how Chennai property sellers can build trust and convert more real estate leads with authenticity, proof, and consistent communication",
//     img: Blog15,
//     link: "blogs/real-estate/real-estate-lead-trust-building-chennai",
//   },
//   {
//     id: 16,
//     category: "realEstate",
//     title: " Ideas to Generate Leads for Luxury Properties in Chennai",
//     date: "30 October 2025",
//     desc: "Are you a real estate business owner in Chennai? Learn expert real estate leads generation strategies for luxury properties, focusing on digital marketing, exclusive events, and making site visits an unforgettable experience. Boost your sales today!",
//     img: Blog16,
//     link: "blogs/real-estate/lead-generation-for-luxury-properties-in-chennai",
//   },
//   {
//     id: 17,
//     category: "realEstate",
//     title:
//       "ATL vs BTL vs TTL Marketing: Which is best for real estate Lead Generation",
//     date: "31 October 2025",
//     desc: "Confused about ATL, BTL, & TTL for real estate leads generation in Chennai? Learn which marketing strategy is best to get high-quality real estate leads for your projects.",
//     img: Blog17,
//     link: "blogs/real-estate/atl-vs-btl-vs-ttl-marketing-real-estate-lead-generation",
//   },
//   {
//     id: 18,
//     category: "realEstate",
//     title: "Real Estate Lead Generation in Tier 2 and 3 Cities in India",
//     date: "31 October 2025",
//     desc: "Unlock effective real estate lead generation in Chennai (and Tamil Nadu's Tier 2/3 cities). Discover hyper-local digital and traditional strategies to capture high-intent real property buyers and secure quality real estate leads in fast-growing markets",
//     img: Blog18,
//     link: "blogs/real-estate/real-estate-lead-generation-tier-2-3-cities-india",
//   },
//   {
//     id: 19,
//     category: "realEstate",
//     title:
//       "The Creative Edge: Best Campaign Creative Types for Real Estate Lead Generation Ads on Meta",
//     date: "12 November 2025",
//     desc: "Stop the scroll! Discover the exact Meta Ads creative types (video, carousel, image) that generate high-quality real estate leads. Learn simple, proven strategies now",
//     img: Blog19,
//     link: "blogs/real-estate/best-real-estate-meta-ads-creative-lead-generation",
//   },
//   {
//     id: 20,
//     category: "realEstate",
//     title:
//       "Real Estate Lead Generation Trends in India: What will Work in 2026",
//     date: "12 November 2025",
//     desc: "The Indian real estate market is changing. Discover the 7 top lead generation trends for 2026: Hyper-Local SEO, Video Marketing, AI, and targeting premium buyers. Get your guide.",
//     img: Blog20,
//     link: "blogs/real-estate/indian-real-estate-lead-generation-trends-2026",
//   },
//   {
//     id: 21,
//     category: "realEstate",
//     title:
//       "Real Estate WhatsApp Follow-Up Techniques to Turn Leads Into Buyers",
//     date: "2 December 2025",
//     desc: " Master the best WhatsApp follow-up techniques for Indian real estate agents. Learn the 5-minute rule, CRM, and high-value content to turn your leads to buyers.",
//     img: Blog21,
//     link: "blogs/real-estate/whatsapp-follow-up-real-estate-leads-india",
//   },
//   {
//     id: 22,
//     category: "realEstate",
//     title:
//       "Real Estate Lead Generation Hack: Achieving the Lowest CPL with Meta Ads",
//     date: "2 December 2025",
//     desc: "Unlock the lowest CPL for real estate lead generation using our proven Meta Ads hack. Learn hyper-targeting and irresistible offers for qualified real estate leads in India.",
//     img: Blog22,
//     link: "blogs/real-estate/real-estate-lead-generation-lowest-cpl-meta-ads",
//   },
//   {
//     id: 23,
//     category: "realEstate",
//     title:
//       "Meta Andromeda Update (2025): The New Blueprint for Real Estate Lead Generation in India",
//     date: "2 December 2025",
//     desc: "The Meta Ads Andromeda Update changes lead generation for Indian real estate business owners. Learn the new AI-driven strategy: focus on creative diversity, Conversions API, and finding high-intent leads",
//     img: Blog23,
//     link: "blogs/real-estate/meta-andromeda-update-real-estate-lead-generation",
//   },

//   {
//     id: 24,
//     category: "realEstate",
//     title: "Create Real Estate Buyer Personas Using ChatGPT (India 2025)",
//     date: "02 December 2025",
//     desc: "Learn how to create real estate buyer personas using ChatGPT. Step-by-step Indian guide to boost property leads, inquiries & conversions in 2025.",
//     img: Blog24,
//     link: "blogs/real-estate/real-estate-buyer-personas-chatgpt-india",
//   },
//   {
//     id: 25,
//     category: "realEstate",
//     title: "Property Videos for Lead Generation in India (2026 Guide)",
//     date: "02 December 2025",
//     desc: "Do property videos really work in India? Learn how real estate video marketing drives high-intent leads, conversions & ROI in the Indian property market.",
//     img: Blog25,
//     link: "blogs/real-estate/property-videos-high-intent-lead-generation-india",
//   },
//   {
//     id: 26,
//     category: "realEstate",
//     title:
//       "How Blaccdot Helps Indian Real Estate Channel Partners Get High-Intent Leads",
//     date: "10 December 2025",
//     desc: "Discover how Blaccdot helps Indian real estate business owners, developers, and channel partners get verified, high-intent property leads using AI-powered qualification and real-time lead distribution.",
//     img: Blog26,
//     link: "blogs/real-estate/how-blaccdot-helps-real-estate-channel-partners-india",
//   },
//   {
//     id: 27,
//     category: "realEstate",
//     title: "How AI Will Transform Real Estate Lead Generation in India by 2026",
//     date: "10 December 2025",
//     desc: "Discover how AI will transform real estate lead generation in India by 2026. Learn how builders and channel partners can generate high-intent buyers faster.",
//     img: Blog27,
//     link: "blogs/real-estate/ai-real-estate-lead-generation-india-2026",
//   },
//   {
//     id: 28,
//     category: "realEstate",
//     title:
//       "AI for Real Estate Lead Follow-Up in India: Automate 80% & Boost Sales",
//     date: "10 December 2025",
//     desc: "Discover how real estate developers in India can automate 80% of lead follow-up using AI. Increase response speed, qualify serious buyers, and scale property sales efficiently.",
//     img: Blog28,
//     link: "blogs/real-estate/real-estate-ai-lead-followup-india",
//   },
// ];

const allBlogs = [
  {
    id: 1,
    category: "realEstate",
    title:
      "How to Get Serious Property Buyers in Dubai Without Wasting Money on Ads",
    date: "27 Februay 2026",
    desc: "Learn how to generate Real Estate Leads Dubai and connect with verified Dubai Property Buyers. Stop wasting ad spend and attract Serious Buyers UAE.",
    img: BlogUAE1,
    link: "blogs/real-estate/how-to-get-serious-property-buyers-in-dubai-without-wasting-money-on-ads",
  },
  {
    id: 2,
    category: "realEstate",
    title: "Why Am I Getting Enquiries but No Property Buyers in UAE?",
    date: "27 Februay 2026",
    desc: "Receiving Property Enquiries Dubai but no serious buyers? Discover how blaccdot quality leads improve Real Estate Conversion UAE.",
    img: BlogUAE2,
    link: "blogs/real-estate/why-am-i-getting-enquiries-but-no-property-buyers-in-UAE?",
  },
  {
    id: 3,
    category: "realEstate",
    title: "How Do Real Estate Developers in UAE Find Verified Buyers?",
    date: "27 Februay 2026",
    desc: "Learn how developers attract Verified Property Buyers UAE using blaccdot Qualified Real Estate Leads Dubai and smart Property Developer Marketing UAE strategies.",
    img: BlogUAE3,
    link: "blogs/real-estate/how-do-real-estate-developers-in-UAE-find-verified-buyers?",
  },
  {
    id: 4,
    category: "realEstate",
    title: "How to Sell Off-Plan Property Faster in Dubai",
    date: "27 Februay 2026",
    desc: "Learn how to Sell Off Plan Property Fast UAE by attracting Off Plan Buyers Dubai and leveraging Dubai Off-Plan Investment 2026 trends.",
    img: BlogUAE4,
    link: "blogs/real-estate/how-to-sell-off-plan-property-faster-in-dubai",
  },
  {
    id: 5,
    category: "realEstate",
    title: "How to Generate Real Estate Leads in Dubai in 2026",
    date: "27 Februay 2026",
    desc: "Learn 7 proven Real Estate Lead Generation Dubai strategies for 2026. Improve property lead generation in the UAE with smarter blaccdot lead generation system 2026.",
    img: BlogUAE5,
    link: "blogs/real-estate/how-to-generate-real-estate-leads-in-dubai-in-2026",
  },
  {
    id: 6,
    category: "realEstate",
    title:
      "Why Meta and Google Ads Fail to Deliver Quality Property Buyers in UAE",
    date: "27 Februay 2026",
    desc: "Struggling with low-quality real estate leads UAE from Meta and Google Ads? Learn why ads fail and how Blaccdot UAE connects you with serious buyers.",
    img: BlogUAE6,
    link: "blogs/real-estate/why-meta-and-google-ads-fail-to-deliver-quality-property-buyers-in-UAE",
  },
];

const Blogs = () => {
  const [filter, setFilter] = useState("all");

  const filteredBlogs = allBlogs.filter(
    (blog) =>
      filter === "all" ||
      blog.category.toLowerCase().trim() === filter.toLowerCase().trim(),
  );

  // Sort by newest first
  const sortedBlogs = [...filteredBlogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );

  return (
    <div>
      <Header />
      <div className="container my-5">
        <Row>
          <Col md={9}>
            <Row className="mb-4">
              <Col md={12}>
                <a
                  href="blogs/e-commerce/10-lean-strategies-to-boost-e-commerce-roas"
                  style={{ textDecoration: "none" }}
                >
                  {/* <Card sx={{ maxWidth: "100%" }}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        height="250"
                        image={Blog1}
                        alt="blog1"
                      />
                      <CardContent>
                        <p style={{ fontSize: "smaller", color: "#676767" }}>
                          Publish Date | 25 November 2024
                        </p>
                        <Typography gutterBottom variant="h5" component="div">
                          10 Lean Strategies to Boost E-commerce ROAS | Blaccdot
                          Guide
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          Discover 10 lean strategies to enhance your e-commerce
                          ROAS and drive sales.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card> */}
                </a>
              </Col>
            </Row>
            <div className="mb-4 pt-2">
              <Typography gutterBottom variant="h3" component="div">
                Blogs
              </Typography>

              <Typography gutterBottom variant="h5" component="div">
                Categories
              </Typography>
            </div>

            <Row className="mb-4 mt-4 filter-buttons">
              {["all", "realEstate", "eCommerce", "health"].map((cat) => (
                <Col key={cat} xs="auto">
                  <button
                    className={`filter-btn ${filter === cat ? "active" : ""}`}
                    onClick={() => setFilter(cat)}
                  >
                    {cat === "all"
                      ? "All"
                      : cat === "realEstate"
                        ? "Real Estate"
                        : cat === "eCommerce"
                          ? "E-Commerce"
                          : cat === "health"
                            ? "Health Care"
                            : cat}
                  </button>
                </Col>
              ))}
            </Row>
          </Col>

          {/* <Col
            md={3}
            className="mb-4"
            style={{ height: "70vh", overflowY: "auto" }}
          >
            <h5 style={{ color: "#1C3046", marginBottom: "20px" }}>
              Pick your favorite
            </h5>
            {allBlogs.map((blog) => (
              <a
                key={blog.id}
                href={blog.link}
                style={{ textDecoration: "none" }}
              >
                <div className="mb-4 blogSidelist">
                  <span style={{ color: "#2763b1", fontSize: "smaller" }}>
                    LEARN
                  </span>
                  <h6 style={{ color: "#554f4f" }}>{blog.title}</h6>
                </div>
              </a>
            ))}
          </Col> */}
        </Row>

        <Row>
          {sortedBlogs.map((blog) => (
            <Col md={4} className="mb-4" key={blog.id}>
              <a href={blog.link} style={{ textDecoration: "none" }}>
                <Card sx={{ maxWidth: "100%" }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="200"
                      image={blog.img}
                      alt={blog.title}
                    />
                    <CardContent>
                      <p style={{ fontSize: "smaller", color: "#676767" }}>
                        Publish Date | {blog.date}
                      </p>
                      <Typography
                        gutterBottom
                        variant="h6"
                        component="div"
                        className="blog-title"
                      >
                        {blog.title}
                      </Typography>

                      <Typography
                        variant="body2"
                        className="blog-desc"
                        sx={{ color: "text.secondary" }}
                      >
                        {blog.desc}
                      </Typography>

                      <a
                        href={blog.link}
                        style={{ color: "#2763b1", fontSize: "14px" }}
                      >
                        Read More →
                      </a>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </div>
      <Footer />
    </div>
  );
};

export default Blogs;

// import React, { useState } from "react";
// import Header from "../components/Header3";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import CardMedia from "@mui/material/CardMedia";
// import Typography from "@mui/material/Typography";
// import CardActionArea from "@mui/material/CardActionArea";
// import { Row, Col } from "react-bootstrap";
// import Blog1 from "../Images/Blog1.jpg";
// import Blog2 from "../Images/blog2.jpg";
// import Blog3 from "../Images/blog3.jpg";
// import Blog4 from "../Images/blog4.jpg";
// import Blog5 from "../Images/blog5.jpg";
// import Blog7 from "../Images/blog7.jpg";
// import Blog8 from "../Images/blog8.jpg";
// import Footer from "../Screen/Footer";

// const Blogs = () => {
//   const [filter, setFilter] = useState("all");
//   return (
//     <div>
//       <Header />
//       <div className="container my-5">
//         <Row>
//           <Col md={9}>
//             <Row>
//               <Col md={12}>
//                 <a
//                   href="/10-lean-strategies-to-boost-e-commerce-roas"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="250"
//                         image={Blog1}
//                         alt="green iguana"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 25 November 2024
//                         </p>
//                         <Typography gutterBottom variant="h5" component="div">
//                           10 Lean Strategies to Boost E-commerce ROAS | Blaccdot
//                           Guide
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Discover 10 lean strategies to enhance your e-commerce
//                           ROAS and drive sales. A must-read guide for business
//                           owners struggling with sales.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>

//               {(filter === "all" || filter === "realEstate") && (
//                 <Col md={6} className="mt-4">
//                   <a
//                     href="/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <Card sx={{ maxWidth: "100%" }}>
//                       <CardActionArea>
//                         <CardMedia
//                           component="img"
//                           height="100%"
//                           image={Blog2}
//                           alt="green iguana"
//                         />
//                         <CardContent>
//                           <p style={{ fontSize: "smaller", color: "#676767" }}>
//                             Publish Date | 25 November 2024
//                           </p>
//                           <Typography gutterBottom variant="h6" component="div">
//                             From Clicks to Visits: Lean Strategies to Convert
//                             Real Estate Leads into Property Viewings
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ color: "text.secondary" }}
//                           >
//                             Struggling to turn real estate leads into property
//                             viewings? Discover lean strategies to optimize your
//                             lead conversion process and drive more visits to
//                             your properties.
//                           </Typography>
//                         </CardContent>
//                       </CardActionArea>
//                     </Card>
//                   </a>
//                 </Col>
//               )}
//               {(filter === "all" || filter === "eCommerce") && (
//                 <Col md={6} className="mt-4">
//                   <a
//                     href="/7-game-changing-tips-to-attract-high-quality-leads-with-meta-ads"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <Card sx={{ maxWidth: "100%" }}>
//                       <CardActionArea>
//                         <CardMedia
//                           component="img"
//                           height="100%"
//                           image={Blog4}
//                           alt="green iguana"
//                         />
//                         <CardContent>
//                           <p style={{ fontSize: "smaller", color: "#676767" }}>
//                             Publish Date | 25 November 2024
//                           </p>
//                           <Typography gutterBottom variant="h6" component="div">
//                             7 Game-Changing Tips to Attract High-Quality Leads
//                             Using Meta Ads
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ color: "text.secondary" }}
//                           >
//                             Meta Ads is a great platform for generating
//                             high-quality leads. In this blog, we'll explore
//                             seven tips to help you attract top-notch leads using
//                             Meta Ads. You'll also learn why focusing on lead
//                             quality.
//                           </Typography>
//                         </CardContent>
//                       </CardActionArea>
//                     </Card>
//                   </a>
//                 </Col>
//               )}
//             </Row>
//           </Col>

//           <Col
//             md={3}
//             className="sign-up-image"
//             style={{ height: "100vh", overflowY: "auto" }}
//           >
//             <h5 style={{ color: "#1C3046", marginBottom: "20px" }}>
//               Pick your favorite
//             </h5>
//             <a
//               href="/10-lean-strategies-to-boost-e-commerce-roas"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   10 Lean Strategies to Boost E-commerce ROAS | Blaccdot Guide
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   From Clicks to Visits: Lean Strategies to Convert Real Estate
//                   Leads into Property Viewings
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/11-proven-ways-to-attract-high-quality-leads-using-google-ads-2024"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   INFORMATION
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   11 Proven Ways to Attract High-Quality Leads Using Google Ads
//                   (2024)
//                 </h6>
//               </div>
//             </a>

//             <a
//               href="/7-game-changing-tips-to-attract-high-quality-leads-with-meta-ads"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   INFORMATION
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   7 Game-Changing Tips to Attract High-Quality Leads Using Meta
//                   Ads
//                 </h6>
//               </div>
//             </a>

//             <a
//               href="/how-to-generate-leads-on-a-zero-marketing-budget-b2c-and-b2b-strategies"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   HOW TO
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   How to Generate Leads on a Zero Marketing Budget: B2C and B2B
//                   Strategies
//                 </h6>
//               </div>
//             </a>

//             <a
//               href="/8-proven-ways-to-get-more-leads-for-your-dental-clinic"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   8 Proven Ways to Get More Leads for Your Dental Clinic
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/google-ads-vs-meta-ads-which-is-better-for-real-estate-lead-generation-in-india-2025"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   Google Ads vs Meta Ads: Which is Better for Real Estate Lead
//                   Generation in India 2025
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/7-proven-ways-to-generate-real-estate-leads-with-google-ads-blaccdot"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   7 Proven Ways to Generate Real Estate Leads Through Google Ads
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/biggest-real-estate-lead-generation-challenges-in-india-and-solutions"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   Biggest Real Estate Lead Generation Challenges in India and
//                   Solutions s{" "}
//                 </h6>
//               </div>
//             </a>
//             <a
//               href="/how-to-create-a-winning-real-estate-leads-funnel-in-india-for-higher-sales"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="mb-4 blogSidelist">
//                 <span style={{ color: "#2763b1", fontSize: "smaller" }}>
//                   LEARN
//                 </span>
//                 <h6 style={{ color: "#554f4f" }}>
//                   How to Create a Winning Real Estate Leads Funnel in India for
//                   Higher Sales
//                 </h6>
//               </div>
//             </a>
//           </Col>
//         </Row>

//         <div className="mt-5">
//           <Row>
//             {(filter === "all" || filter === "eCommerce") && (
//               <Col md={4}>
//                 <a
//                   href="/11-proven-ways-to-attract-high-quality-leads-using-google-ads-2024"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog3}
//                         alt="green iguana"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 25 November 2024
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           11 Proven Ways to Attract High-Quality Leads Using
//                           Google Ads (2024)
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Google Ads is the best way to attract High-converting
//                           leads that drive business growth. To ensure your ads
//                           reach potential customers, it's crucial to use
//                           targeted strategies.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "eCommerce") && (
//               <Col md={4}>
//                 <a
//                   href="/how-to-generate-leads-on-a-zero-marketing-budget-b2c-and-b2b-strategies"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog5}
//                         alt="green iguana"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 25 November 2024
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           How to Generate Leads on a Zero Marketing Budget: B2C
//                           and B2B Strategies
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Generating leads is important for any business. There
//                           are effective ways to attract potential customers and
//                           clients without spending money. In this guide, we'll
//                           look at lead generation
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog1}
//                         alt="green iguana"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 25 November 2024
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           From Clicks to Visits: Lean Strategies to Convert Real
//                           Estate Leads into Property Viewings
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Struggling to turn real estate leads into property
//                           viewings? Discover lean strategies to optimize your
//                           lead conversion process and drive more visits to your
//                           properties.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//           </Row>
//         </div>

//         <div className="mt-5">
//           <Row>
//             {(filter === "all" || filter === "health") && (
//               <Col md={4}>
//                 <a
//                   href="/8-proven-ways-to-get-more-leads-for-your-dental-clinic"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog1} //need image
//                         alt="Blog6"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           8 Proven Ways to Get More Leads for Your Dental Clinic
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Strategies to boost patient acquisition for your
//                           dental clinic. Explore both organic and paid lead
//                           generation methods to attract, engage, and convert
//                           prospective patients.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/google-ads-vs-meta-ads-which-is-better-for-real-estate-lead-generation-in-india-2025"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog7} //need image
//                         alt="Blog7"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           Google Ads vs Meta Ads: Which is Better for Real
//                           Estate Lead Generation in India 2025
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Explore the differences between Google Ads and Meta
//                           Ads for real estate lead generation in India. Discover
//                           which platform suits your business goals, and learn
//                           best practices for maximizing your advertising efforts
//                           in 2025.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/7-proven-ways-to-generate-real-estate-leads-with-google-ads-blaccdot"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog8} //need image
//                         alt="Blog8"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           7 Proven Ways to Generate Real Estate Leads with
//                           Google Ads | Blaccdot
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           The proven strategies to generate high-quality real
//                           estate leads using Google Ads. Optimize your campaigns
//                           with effective keyword targeting, compelling ad copy,
//                           and efficient lead management with Blaccdot.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//           </Row>
//         </div>

//         <div className="mt-5">
//           <Row>
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/biggest-real-estate-lead-generation-challenges-in-india-and-solutions"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog1} //need image
//                         alt="Blog9"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           Biggest Real Estate Lead Generation Challenges in
//                           India and Solutions
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Strategies to boost patient acquisition for your
//                           dental clinic. Explore both organic and paid lead
//                           generation methods to attract, engage, and convert
//                           prospective patients.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//             {(filter === "all" || filter === "realEstate") && (
//               <Col md={4}>
//                 <a
//                   href="/how-to-create-a-winning-real-estate-leads-funnel-in-india-for-higher-sales"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Card sx={{ maxWidth: "100%" }}>
//                     <CardActionArea>
//                       <CardMedia
//                         component="img"
//                         height="100%"
//                         image={Blog1} //need image
//                         alt="Blog10"
//                       />
//                       <CardContent>
//                         <p style={{ fontSize: "smaller", color: "#676767" }}>
//                           Publish Date | 23 September 2025
//                         </p>
//                         <Typography gutterBottom variant="h6" component="div">
//                           How to Create a Winning Real Estate Leads Funnel in
//                           India for Higher Sales
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{ color: "text.secondary" }}
//                         >
//                           Explore the differences between Google Ads and Meta
//                           Ads for real estate lead generation in India. Discover
//                           which platform suits your business goals, and learn
//                           best practices for maximizing your advertising efforts
//                           in 2025.
//                         </Typography>
//                       </CardContent>
//                     </CardActionArea>
//                   </Card>
//                 </a>
//               </Col>
//             )}
//           </Row>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default Blogs;
